
window.imajize = {};
// CONFIGURATON BEGIN
// CSS path to find the image container: please adjust to match the container holding your images, depends on the theme
window.imajize.container_path = ".theme-images";

// CONFIGURATON END
(function() {

  // Act on product pages only
  if (location.href.indexOf("/products/") > -1) {

    // Find container
    window.imajize.container = document.querySelector(window.imajize.container_path);

    // Find images
    window.imajize.images = window.imajize.container.querySelectorAll('img[alt*="imajize"]');

    for (let image of window.imajize.images) {

      // Find Imajize UUID
      let uuid = image.alt.match(/.*imajize.*\/([\d\w-_]+).*/)[1];

      // Stop if no UUID provided
      if (!uuid) {
        return;
      }

      // Find dimensions (optionally, try using width instead of offsetWidth and height instead of offsetHeight)
      let width = image.offsetWidth;
      let height = image.offsetHeight;
      let ratio = height / width;

      // Build Imajize iframe
      let iframe = '' +
        '<div class="imajize" ' +
        'style="margin: 0 auto; padding: ' + Math.round(100 * ratio) + '% 0 0 0; width: 100%; position: relative;">' +
        '<iframe src="https://embed.imajize.com/' + uuid + '" allowfullscreen="" frameborder="0" scrolling="no" style="background-color: #fff; position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>' +
        '</div>';

      // Insert Imajize iframe
      image.parentElement.parentElement.innerHTML = iframe;

    }
  }

})();
